export var PackageDimensionsAndWeight = function PackageDimensionsAndWeight(strictLocalize) {
  return {
    titleBuilder: function titleBuilder() {
      return packageDimensionsAndWeightBuilder(strictLocalize).getTitle();
    },
    descriptionBuilder: function descriptionBuilder() {
      return packageDimensionsAndWeightBuilder(strictLocalize).getDescription();
    }
  };
};
var packageDimensionsAndWeightBuilder = function packageDimensionsAndWeightBuilder(strictLocalize) {
  return {
    getTitle: function getTitle() {
      return strictLocalize({
        id: "kVBhvj",
        defaultMessage: [{
          "type": 0,
          "value": "Restrições de embalagem no Envio com a Faire"
        }]
      });
    },
    getDescription: function getDescription() {
      return [strictLocalize({
        id: "yAuVAD",
        defaultMessage: [{
          "type": 0,
          "value": "Quando estiver a utilizar o Envio com a Faire, aplicam-se as restrições de peso e dimensão das embalagens da transportadora. Leia os artigos do Centro de Ajuda que encontrámos para compreender as suas opções ou contacte-nos para obter mais ajuda. Pode também tentar usar outra transportadora ou escolher a opção Enviar por conta própria."
        }]
      })];
    }
  };
};